import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Merges conditional class names and resolves conflicting Tailwind utilities.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Normalizes a person's name to title case per part, splitting on spaces and hyphens ("MARY ANN" becomes "Mary Ann").
export function formatName(name: string): string {
  return name.replace(
    /[^\s-]+/g,
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );
}
